export const BETTING_CARDS_GET = 'BETTING_CARDS_GET';
export const BETTING_CARDS_GET_REQUEST = 'BETTING_CARDS_GET_REQUEST';
export const BETTING_CARDS_GET_SUCCESS = 'BETTING_CARDS_GET_SUCCESS';
export const BETTING_CARDS_GET_FAILURE = 'BETTING_CARDS_GET_FAILURE';

export const BETTING_CARDS_PUT = 'BETTING_CARDS_PUT';
export const BETTING_CARDS_PUT_REQUEST = 'BETTING_CARDS_PUT_REQUEST';
export const BETTING_CARDS_PUT_SUCCESS = 'BETTING_CARDS_PUT_SUCCESS';
export const BETTING_CARDS_PUT_FAILURE = 'BETTING_CARDS_PUT_FAILURE';
